var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCash = function SvgCash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 13.999
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cash_svg__a",
    x1: -0.062,
    y1: 0.061,
    x2: 0.694,
    y2: 0.583,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef437e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef2c6d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "money (1)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2647"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 18628",
    d: "M19.738 2.869h-2.355l-14.694 7.21v2.565a1.391 1.391 0 0 0 1.356 1.355h15.7a1.3 1.3 0 0 0 1.261-1.33V4.272a1.323 1.323 0 0 0-1.234-1.4Z",
    fill: "#e0c3cd"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 18629",
    d: "M18.336 81.6v6.751A1.344 1.344 0 0 1 17 89.711H1.308A1.32 1.32 0 0 1 0 88.38v-8.372a1.32 1.32 0 0 1 1.284-1.355H17a1.344 1.344 0 0 1 1.332 1.355v1.6Z",
    transform: "translate(0 -78.653)",
    fill: "url(#cash_svg__a)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2648",
    transform: "translate(1.452 1.234)",
    fill: "#ff86af"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 96",
    cx: 0.968,
    cy: 0.968,
    r: 0.968,
    transform: "translate(13.792 6.46)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 97",
    cx: 4.307,
    cy: 4.307,
    r: 4.307,
    transform: "translate(3.557)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 98",
    cx: 0.968,
    cy: 0.968,
    r: 0.968,
    transform: "translate(0 .169)"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 18630",
    d: "M10.467 5.844c0 .714-.378 1.2-1.043 1.2-.322 0-.609-.112-.609-.483V5.529h.371v-.735h-.371v-.3c0-.84-.378-1.316-1.239-1.316-.091 0-.224.007-.322.014v.847h.205c.294 0 .4.1.4.483v.273h-.6v.735h.6v1.036c0 .9.672 1.323 1.561 1.323a1.868 1.868 0 0 0 1.957-2.052 1.124 1.124 0 0 0-1.176-1.232 1.189 1.189 0 0 0-.714.252l.4.749a.354.354 0 0 1 .259-.112.313.313 0 0 1 .321.35Z",
    fill: "#fedb41"
  }))));
};
export default SvgCash;